// extracted by css-extract-rspack-plugin
export default {"wrapper":"_13f76e2f","breadcrumbItem":"_f1098912"};